import {
  ajaxErrorAlert,
  ajaxPost,
  parceAjaxErrorResponse,
  toggleBetweenElements,
} from "./utils";
import { ErrorSwal, getJsContext, SuccessSwal } from "../app";
import { bsModal } from "./plugins";

const body = $("body");
if (body.hasClass("extra_compulsory")) {
  const extraCompulsorySecondForm = $("#extraCompulsorySecondForm");
  const extraCompulsoryFirstForm = $("#extraCompulsoryFirstForm");
  const extraCompulsoryPaymentForm = $("#extraCompulsoryPaymentForm");
  const checkPaymentForm = $("#checkPaymentForm");
  const extraCompulsoryPolicyForm = $("#extraCompulsoryPolicyForm");

  extraCompulsoryFirstForm.on("submit", function (e) {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();
    data.push({
      name: "action",
      value: "get_pme_info",
    });
    form.loading({
      loadingText: getJsContext("loading"),
      action: "show",
      extraClasses: "spinner-fixed",
    });
    ajaxPost("", data, form)
      .then((response) => {
        const policy_id = response["policy_id"],
          pin = response["pin"],
          phone_number = response["phone_number"],
          policy_number = response["policy_number"],
          insurance_start_date = response["insurance_start_date"],
          insurance_end_date = response["insurance_end_date"],
          plate_number = response["dqn"],
          status = response["status"];

        $("#extraCompulsorySecondForm #pin").val(pin);
        $("#extraCompulsorySecondForm #phone_number").val(phone_number);
        $("#pme_policy_id").val(policy_id);
        $("#pme_policy_number").val(policy_number);
        $("#pme_start_date").val(insurance_start_date);
        $("#pme_end_date").val(insurance_end_date);
        $("#extraCompulsorySecondForm #plate_number").val(plate_number);
        $("#status").val(status);

        extraCompulsorySecondForm.loading({ action: "hide" });
        toggleBetweenElements(
          extraCompulsoryFirstForm,
          extraCompulsorySecondForm,
        );

        $("html, body").animate(
          {
            scrollTop: 0,
          },
          400,
        );
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  extraCompulsorySecondForm.on("submit", function (e) {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();
    data.push({
      name: "action",
      value: "create_policy",
    });
    form.loading({
      loadingText: getJsContext("loading"),
      action: "show",
      extraClasses: "spinner-fixed",
    });
    ajaxPost("", data, form)
      .then((response) => {
        window.location.href = response["redirect_url"];
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          400,
        );
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  extraCompulsoryPaymentForm.on("submit", function (e) {
    e.preventDefault();
    const form = $(e.target);
    form.loading({
      action: "show",
      loadingText: getJsContext("please_wait") + "...",
      extraClasses: "spinner-fixed",
    });
    ajaxPost("", { action: "get_payment_url_from_wims_payment" }, form)
      .then((response) => {
        form.loading({
          action: "show",
          loadingText: getJsContext("redirecting") + "...",
          extraClasses: "spinner-fixed",
        });
        window.top.location.href = response["redirect_url"];
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  $("#backToFirstForm").on("click", (e) => {
    e.preventDefault();
    const extraCompulsoryFirstForm = $("#extraCompulsoryFirstForm");
    const extraCompulsorySecondForm = $("#extraCompulsorySecondForm");
    toggleBetweenElements(extraCompulsorySecondForm, extraCompulsoryFirstForm);
  });

  $(".downloadPaymentReceipt").on("click", (e) => {
    const button = $(e.currentTarget);
    const paymentId = button.data("payment-id");

    const data = {
      action: "get_payment_receipt_pdf",
      payment_id: paymentId,
    };

    extraCompulsoryPolicyForm.loading({
      action: "show",
      loadingText: getJsContext("preparing") + "...",
    });

    ajaxPost("", data, extraCompulsoryPolicyForm)
      .then((response) => {
        extraCompulsoryPolicyForm.loading({
          action: "show",
          loadingText: getJsContext("loading") + "...",
        });
        const data = `data:${response["content_type"]};base64,${response["base64"]}`;
        const link = document.createElement("a");
        link.href = data;
        link.download = String(response["file_name"]);
        link.click();
        setTimeout(() => {
          extraCompulsoryPolicyForm.loading({ action: "hide" });
        }, 1500);
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, extraCompulsoryPolicyForm);
      });
  });

  $(".downloadExtraCompulsoryPolicy").on("click", (e) => {
    const button = $(e.currentTarget);
    const policyNumber = button.data("policy-number");

    const data = {
      action: "get_policy_pdf",
      policy_number: policyNumber,
    };

    extraCompulsoryPolicyForm.loading({
      action: "show",
      loadingText: getJsContext("preparing") + "...",
    });

    ajaxPost("", data, extraCompulsoryPolicyForm)
      .then((response) => {
        extraCompulsoryPolicyForm.loading({
          action: "show",
          loadingText: getJsContext("loading") + "...",
        });
        const data = `data:${response["content_type"]};base64,${response["base64"]}`;
        const link = document.createElement("a");
        link.href = data;
        link.download = String(response["file_name"]);
        link.click();
        setTimeout(() => {
          extraCompulsoryPolicyForm.loading({ action: "hide" });
        }, 1500);
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, extraCompulsoryPolicyForm);
      });
  });

  $(".sendExtraCompulsoryPolicy").on("click", (e) => {
    const button = $(e.currentTarget);
    const policyNumber = button.data("policy-number");

    const data = {
      action: "send_email_modal",
      policy_number: policyNumber,
    };

    const modal = bsModal("medium", {
      title: getJsContext("send_policy_to_email"),
      modalId: "sendExtraCompulsoryPolicyModal",
      backdrop: "none",
      keyboard: true,
    });

    ajaxPost("", data)
      .then((response) => {
        $(modal).modal("content", response["html"]);
      })
      .catch((errors) => {
        ErrorSwal.fire({
          html: parceAjaxErrorResponse(errors),
        }).then(() => {
          $(modal).modal("hide");
        });
      });
  });

  $(document).on("submit", "#sendExtraCompulsoryPolicyEmailForm", (e) => {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();
    data.push({ name: "action", value: "send_email" });
    form.loading({ action: "show" });
    ajaxPost("", data, form)
      .then(() => {
        SuccessSwal.fire({ timer: 1000 }).then(() => {
          form.closest(".modal").modal("hide");
        });
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  if (checkPaymentForm.length) {
    ajaxPost("", { action: "check_payment" }, checkPaymentForm)
      .then((response) => {
        window.location.href = response["redirect_url"];
      })
      .catch((errors) => {
        $("#pageFirstLoading").remove();
        ajaxErrorAlert(errors, checkPaymentForm);
      });
  }
}
